<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">FAQs</h5>
                  </div>
                  <small class="text-truncate text-muted">What is this?</small>
                </div>
              </div>
            </div>
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="btn btn-sm btn-dark" href="javascript:void(0)">Create new</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">List view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Grid view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add new</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>

            </div>

          </div> <!-- .row end -->

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-3">
        <div class="container px-0">

          <!-- Invoice:  -->
          <div class="row py-lg-5 py-2">
            <div class="col-md-4 col-sm-12">
              <div class="mb-4">
                <h6>Useful tips</h6>
                <p class="text-muted">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                  euismod tincidunt.</p>
                <div class="list-group custom">
                  <a class="list-group-item" href="#"><i class="zmdi zmdi-circle small me-2 text-danger"></i>Lorem
                    ipsum</a>
                  <a class="list-group-item" href="#"><i class="zmdi zmdi-circle small me-2 text-info"></i>Consectetuer
                    adipiscing</a>
                  <a class="list-group-item" href="#"><i class="zmdi zmdi-circle small me-2 text-primary"></i>Sed diam
                    nonummy</a>
                  <a class="list-group-item" href="#"><i class="zmdi zmdi-circle small me-2 text-warning"></i>Euismod
                    tincidunt</a>
                </div>
              </div>

              <div class="mb-3">
                <h6>Can't find the answer? </h6>
                <p class="text-muted">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                  euismod tincidunt.</p>
                <a href="#" class="btn btn-primary">Contact us</a>
              </div>
            </div>

            <div class="col-md-8 col-sm-12">
              <!-- Card: -->
              <div class="card">
                <div class="card-body">
                  <h6>General</h6>
                  <div id="demo-gen-faq" class="accordion border-bottom mb-4">
                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isgenCollapsed = !isgenCollapsed"
                          [attr.aria-expanded]="!isgenCollapsed" aria-controls="collapseBasic">Lorem ipsum dolor sit
                          amet
                          ?</a>
                        <div id="collapseBasic" [collapse]="isgenCollapsed" [isAnimated]="true" class="collapse in">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed2 = !isCollapsed2"
                          [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseBasic2">Consectetuer adipiscing
                          elit ?</a>
                        <div id="collapseBasic2" [collapse]="isCollapsed2" [isAnimated]="true" class="in py3
                          collapse">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed3 = !isCollapsed3"
                          [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseBasic3">Sed diam
                          nonummy nibh euismod tincidunt ?</a>
                        <div id="collapseBasic3" [collapse]="isCollapsed3" [isAnimated]="true" class="in py3
                                                    collapse">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.

                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed4 = !isCollapsed4"
                          [attr.aria-expanded]="!isCollapsed4" aria-controls="collapseBasic4">Tincidunt ut laoreet
                          dolore magna ?</a>
                        <div id="collapseBasic4" [collapse]="isCollapsed4" [isAnimated]="true" class="in py3
                                                    collapse">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->
                  </div>

                  <!-- ACCOUNT -->
                  <h6>Account</h6>
                  <div id="demo-acc-faq" class="accordion mb-4">
                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed5 = !isCollapsed5"
                          [attr.aria-expanded]="!isCollapsed5" aria-controls="collapseBasic5">Lorem ipsum dolor sit amet
                          ?</a>
                        <div id="collapseBasic5" [collapse]="isCollapsed5" [isAnimated]="true" class="in py3
                                                                          collapse">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed6 = !isCollapsed6"
                          [attr.aria-expanded]="!isCollapsed6" aria-controls="collapseBasic6">Consectetuer adipiscing
                          elit ?</a>
                        <div id="collapseBasic6" [collapse]="isCollapsed6" [isAnimated]="true" class="in py3
                                                                                                    collapse">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed7 = !isCollapsed7"
                          [attr.aria-expanded]="!isCollapsed7" aria-controls="collapseBasic7">Sed diam nonummy nibh
                          euismod tincidunt ?</a>
                        <div id="collapseBasic7" [collapse]="isCollapsed7" [isAnimated]="true"
                          class="in py3
                                                                                                                                collapse">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->
                  </div>

                  <!-- PAYMENT -->
                  <h6 class="pad-all bord-btm text-thin">Payment</h6>
                  <div id="demo-pym-faq" class="accordion">
                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed8 = !isCollapsed8"
                          [attr.aria-expanded]="!isCollapsed8" aria-controls="collapseBasic8">Lorem ipsum dolor
                          sit amet ?</a>
                        <div id="collapseBasic8" [collapse]="isCollapsed8" [isAnimated]="true" class="collapse in">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed9 = !isCollapsed9"
                          [attr.aria-expanded]="!isCollapsed9" aria-controls="collapseBasic9">Consectetuer
                          adipiscing elit ?</a>
                        <div id="collapseBasic9" [collapse]="isCollapsed9" [isAnimated]="true" class="collapse in">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed10 = !isCollapsed10"
                          [attr.aria-expanded]="!isCollapsed10" aria-controls="collapseBasic10">Sed diam nonummy
                          nibh euismod tincidunt ?</a>
                        <div id="collapseBasic10" [collapse]="isCollapsed10" [isAnimated]="true" class="collapse in">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                    <div class="mb-1">
                      <div class="py-2 px-3 bg-light text-dark">
                        <a href="javascript:void(0)" (click)="isCollapsed11 = !isCollapsed11"
                          [attr.aria-expanded]="!isCollapsed11" aria-controls="collapseBasic11">Tincidunt ut
                          laoreet dolore magna ?</a>
                        <div id="collapseBasic11" [collapse]="isCollapsed11" [isAnimated]="true" class="collapse in">
                          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                          tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                          nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </div>
                      </div>
                    </div> <!-- Question -->

                  </div>

                </div>
              </div>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
